module.exports = __webpack_public_path__ + "assets/logout-icon.fbb6c9b125e04ebaa490e04f978ea6ff.svg";